import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/img/icons/done.svg'


const _hoisted_1 = { class: "row h-100" }
const _hoisted_2 = {
  key: 1,
  class: "col-md-12 grid-margin stretch-card"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_6 = { class: "form-group mr-b-0em" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_9 = {
  key: 2,
  class: "col-md-6"
}
const _hoisted_10 = { class: "form-group mr-b-0em" }
const _hoisted_11 = {
  key: 3,
  class: "col-md-6"
}
const _hoisted_12 = { class: "form-group mr-b-0em" }
const _hoisted_13 = {
  key: 4,
  class: "col-md-6"
}
const _hoisted_14 = { class: "form-group mr-b-0em" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "form-group mr-b-0em" }
const _hoisted_17 = { class: "col-md-12 mt-5" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-12 mb-5" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "form__label" }
const _hoisted_22 = { class: "form__label" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-12 text-right" }
const _hoisted_25 = {
  type: "submit",
  class: "btn btn-primary mr-2"
}
const _hoisted_26 = {
  key: 2,
  class: "col-md-12 grid-margin stretch-card d-flex justify-content-center align-items-center"
}
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "img-access-rapide w-50",
    src: _imports_0,
    alt: "Selected Image"
  })
], -1)
const _hoisted_29 = { class: "green" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_SingleSelect = _resolveComponent("SingleSelect")!
  const _component_date_field = _resolveComponent("date-field")!
  const _component_inputText = _resolveComponent("inputText")!
  const _component_price_input = _resolveComponent("price-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isRequestPayment)
      ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.subscription_details?.is_paid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("form", {
            class: "forms-sample",
            onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_SingleSelect, {
                  TextLabel: _ctx.i18n.t('tables.payment.status'),
                  trackby: `id`,
                  label: `name`,
                  valueProp: `id`,
                  modelValue: _ctx.requestPayment.status,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestPayment.status) = $event)),
                  placeholder: _ctx.i18n.t('tables.payment.status'),
                  arrayOptions: _ctx.payementStatusList,
                  refs: "status",
                  v: _ctx.v$.status
                }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
              ]),
              (_ctx.requestPayment.status == 'paid')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_date_field, {
                        modelValue: _ctx.requestPayment.paymentDate,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestPayment.paymentDate) = $event)),
                        label: _ctx.i18n.t('tables.payment.paymentDate'),
                        v: _ctx.v$.paymentDate,
                        disabled: false
                      }, null, 8, ["modelValue", "label", "v"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_SingleSelect, {
                  TextLabel: _ctx.i18n.t('tables.payment.paymentMethod'),
                  trackby: `id`,
                  label: `name`,
                  valueProp: `id`,
                  modelValue: _ctx.requestPayment.paymentMethod,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestPayment.paymentMethod) = $event)),
                  placeholder: _ctx.i18n.t('tables.payment.paymentMethod'),
                  arrayOptions: _ctx.payment_methodsList,
                  refs: "paymentMethod",
                  v: _ctx.v$.paymentMethod
                }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
              ]),
              (_ctx.requestPayment.paymentMethod === 'Chèque bancaire')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_SingleSelect, {
                      TextLabel: _ctx.i18n.t('tables.payment.bankName'),
                      trackby: `id`,
                      label: `name`,
                      valueProp: `id`,
                      modelValue: _ctx.requestPayment.bankName,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestPayment.bankName) = $event)),
                      placeholder: _ctx.i18n.t('tables.payment.bankName'),
                      arrayOptions: _ctx.bank_namesList,
                      refs: "bankName",
                      v: _ctx.v$.bankName
                    }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.requestPayment.paymentMethod === 'Chèque bancaire')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_inputText, {
                        modelValue: _ctx.requestPayment.chequeName,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestPayment.chequeName) = $event)),
                        label: _ctx.i18n.t('tables.payment.chequeName'),
                        v: _ctx.v$.chequeName,
                        disabled: false
                      }, null, 8, ["modelValue", "label", "v"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.requestPayment.paymentMethod === 'Chèque bancaire')
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_inputText, {
                        modelValue: _ctx.requestPayment.chequeNum,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requestPayment.chequeNum) = $event)),
                        label: _ctx.i18n.t('tables.payment.chequeNum'),
                        v: _ctx.v$.chequeNum,
                        disabled: false
                      }, null, 8, ["modelValue", "label", "v"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.requestPayment.paymentMethod === 'Chèque bancaire' || _ctx.requestPayment.status == 'scheduled')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_date_field, {
                        modelValue: _ctx.requestPayment.dueDate,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestPayment.dueDate) = $event)),
                        label: _ctx.requestPayment.status == 'scheduled' ? _ctx.i18n.t('tables.payment.accessBlockDate') : _ctx.i18n.t('tables.payment.dueDate'),
                        v: _ctx.v$.dueDate,
                        disabled: false,
                        fixedDays: 1,
                        isFixedDays: false
                      }, null, 8, ["modelValue", "label", "v"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_price_input, {
                    modelValue: _ctx.requestPayment.amount_paid,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requestPayment.amount_paid) = $event)),
                    label: _ctx.i18n.t('tables.payment.amount_paid'),
                    v: _ctx.v$.amount_paid,
                    disabled: false
                  }, null, 8, ["modelValue", "label", "v"])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("p", _hoisted_21, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.i18n.t('views.clients.new_subscriptions.payment.regulation.net_total')), 1),
                        _createTextVNode(" : " + _toDisplayString(_ctx.totalRemainingAmount) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
                      ]),
                      _createElementVNode("p", {
                        class: _normalizeClass(["form__label", { 'bg-validator': _ctx.v$.amount_paid.$error }])
                      }, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.i18n.t('views.clients.new_subscriptions.payment.regulation.total_paid')) + " : ", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.requestPayment.amount_paid), 1)
                      ], 2),
                      _createElementVNode("p", _hoisted_22, [
                        _createElementVNode("b", null, _toDisplayString(_ctx.i18n.t('views.clients.new_subscriptions.payment.regulation.remaining_amount')), 1),
                        _createTextVNode(" :" + _toDisplayString(_ctx.remainingAmount) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("button", _hoisted_25, _toDisplayString(_ctx.i18n.t('button.pay')), 1),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.emptyState())),
                  class: "btn btn-cancel"
                }, _toDisplayString(_ctx.i18n.t('button.cancel')), 1)
              ])
            ])
          ], 32)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("b", _hoisted_29, _toDisplayString(_ctx.i18n.t('views.clients.unpaid.pay.paid')), 1)
          ])
        ]))
  ]))
}